import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { EstateAccount } from '@/modules/estateaccount/models/EstateAccount';
import { User } from '@/modules/user/models/User';

export class ConversationUser extends BaseEntityModel {
  id?: number;
  userId?: number;
  conversationId?: number;
  user?: Relationship<User | null>;
  estateAccount?: Relationship<EstateAccount | null>;

  constructor(model: Partial<ConversationUser> = {}) {
    super(model);

    this.id = model.id;
    this.userId = model.userId;
    this.conversationId = model.conversationId;
    this.user = User.mapModelOrNull(model.user);
    this.estateAccount = EstateAccount.mapModelOrNull(model.estateAccount);
  }
}
